import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {
  respObject: any;
  respDel: any;
  haveData:boolean;
  fileData:any;

  perPageRow = this._rest.PER_PAGE_ROW;
  curPage = 1;
  totalRows = 0;
  pages = [];
  noOfRows=0;

  userRole="";
  companyName="";
  companyCode="";
  email="";
  username="";

  constructor(private router: Router, private _rest: RestapiService) { 
    this.haveData=false;
  }

  ngOnInit(): void {
  	const userId = localStorage.getItem('userId');
  	const companyId = localStorage.getItem('companyId');
    this.searchUser(1);
  }

  userDelete(id){
    if(confirm("Are you sure to delete?")){
      //alert(id)
      var delData = {"id":id}
      this._rest.delUser(delData).subscribe((res) => {
        this.respDel = res;
        if(this.respDel.error==0){
          //alert("User delete Successfully.");
          this.searchUser(1);
           // window.location.reload();
        } else {
          alert(this.respDel.errorMessage);
        }
      })
    }
  }

  gotoEditPage(id){
    this.router.navigate(['/admin/edituser/'+id]);
  }
  gotoAuditPage(id){
    this.router.navigate(['/admin/useraudit/'+id]);
  }
  searchUser(curPage){
    this.curPage = curPage;
    var fd = {};
    
    fd["limit"]=this.perPageRow;
    fd["page"]=this.curPage;
    fd["userRole"]=this.userRole;
    
    fd["email"]=this.email;
    fd["companyName"]=this.companyName;
    fd["companyCode"]=this.companyCode;
    fd["username"]=this.username;
    
    //console.log(fd);
    this._rest.userList(fd).subscribe((res) => {
      this.respObject = res;
      if(this.respObject.details!=undefined){
        if(this.respObject.details.data!=undefined){
          this.fileData=this.respObject.details.data;
          this.totalRows = this.respObject.details.info;
          this.noOfRows=this.respObject.details.data.length;
          this.pages=[];
          for (var i=1;i<=Math.ceil(this.totalRows/this.perPageRow);i++){
            this.pages.push(i);
          }
        } else {
          this.fileData=[];
          this.totalRows = 0;
          this.noOfRows = 0;
          this.pages=[];
        }
      } else {
        this.fileData=[];
        this.totalRows = 0;
        this.noOfRows = 0;
        this.pages=[];
      }
      console.log(JSON.stringify(this.respObject));
    })
  }
}
